import { z } from 'zod';

export const eventFormSchema = z.object({
  title: z.string()
    .min(1, 'El título es requerido')
    .max(255, 'El título debe tener máximo 255 caracteres'),
  description: z.string()
    .max(2000, 'La descripción debe tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  event_type: z.enum(['maintenance', 'meeting', 'deadline', 'training', 'production', 'other'])
    .default('other'),
  start_date: z.string()
    .min(1, 'La fecha de inicio es requerida'),
  end_date: z.string()
    .optional()
    .or(z.literal('')),
  all_day: z.boolean().default(false),
  location: z.string()
    .max(255, 'La ubicación debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  priority: z.number()
    .int('Debe ser un número entero')
    .min(0, 'La prioridad debe ser entre 0 y 10')
    .max(10, 'La prioridad debe ser entre 0 y 10')
    .default(0),
  status: z.enum(['scheduled', 'in_progress', 'completed', 'cancelled'])
    .default('scheduled'),
  related_to_type: z.string()
    .max(50, 'El tipo de relación debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  related_to_id: z.string()
    .uuid('Debe ser un UUID válido')
    .optional()
    .or(z.literal('')),
  reminder_minutes: z.number()
    .int('Debe ser un número entero')
    .min(0, 'Los minutos de recordatorio deben ser mayores o iguales a 0')
    .optional(),
  attendees: z.array(z.string()).optional().default([]),
  is_general: z.boolean().default(true),
  visible_to_user_ids: z.array(z.string().uuid()).optional().default([]),
  is_active: z.boolean().default(true),
}).superRefine((data, ctx) => {
  if (!data.is_general && (!data.visible_to_user_ids || data.visible_to_user_ids.length === 0)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Selecciona al menos un usuario para el evento',
      path: ['visible_to_user_ids'],
    });
  }
});

export type EventFormData = z.infer<typeof eventFormSchema>;
